const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export async function retry<T>(
  callback: () => Promise<T>,
  retries: number,
  delay = 500,
  backoffMultiplier = 2
): Promise<T> {
  async function attempt(attemptNumber: number): Promise<T> {
    try {
      return await callback();
    } catch (error) {
      if (attemptNumber >= retries) {
        throw error;
      }
      const currentDelay = delay * Math.pow(backoffMultiplier, attemptNumber);
      await sleep(currentDelay);
      return attempt(attemptNumber + 1);
    }
  }

  return attempt(0);
}
